/**
 * Normalizes any thrown/rejected value to an Error so the logger always has
 * a stack. Handles cross-realm errors (e.g. jsdom DOMException) that fail
 * `instanceof Error`.
 */
export function toError(value: unknown, fallbackMessage = 'Error'): Error {
  if (value instanceof Error) return value;
  const e = value as { name?: unknown; message?: unknown } | null;
  let message = fallbackMessage;
  if (typeof value === 'string' && value) {
    message = value;
  } else if (typeof e?.message === 'string' && e.message) {
    message = e.message;
  }
  const wrapped = new Error(message);
  if (typeof e?.name === 'string' && e.name) wrapped.name = e.name;
  return wrapped;
}
